/* Lykos theme: header, menu, cart drawer (Shopify Ajax Cart API), quick add, product form */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const L = window.LYKOS || { root: '/', cartUrl: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  const money = cents => new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format((cents || 0) / 100);
  const esc = v => String(v == null ? '' : v).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sized = (url, w) => url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';

  /* ---------- toast ---------- */
  let tt;
  function toast(msg) {
    const t = $('#toast');
    if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(tt); tt = setTimeout(() => t.classList.remove('on'), 2600);
  }

  /* ---------- header on scroll ---------- */
  const top = $('#top');
  if (top) {
    const onScroll = () => top.classList.toggle('is-scrolled', window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- overlays ---------- */
  const bagEl = $('#bag'), scrim = $('#scrim'), mnav = $('#mnav');
  let lastFocus = null;
  function lock() {
    const bagOn = !!(bagEl && bagEl.classList.contains('on'));
    const menuOn = !!(mnav && mnav.classList.contains('on'));
    document.documentElement.style.overflow = bagOn || menuOn ? 'hidden' : '';
    $$('[data-inertable]').forEach(el => { el.inert = bagOn || menuOn; });
    const hdr = $('.hdr'); if (hdr) hdr.inert = bagOn;
  }

  /* ---------- cart ---------- */
  async function fetchCart() {
    const r = await fetch(L.cartUrl + '.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }
  function renderCart(cart) {
    $$('[data-count]').forEach(el => { el.textContent = cart.item_count; el.dataset.n = cart.item_count; });
    $$('[data-count-plain]').forEach(el => { el.textContent = cart.item_count; });
    const list = $('#bag-items'), foot = $('#bag-foot'), total = $('#bag-total');
    if (!list) return;
    if (!cart.item_count) {
      list.innerHTML = `<div class="bag-empty"><p>Your bag is empty.</p><a class="btn btn-line" href="${esc(L.root)}" data-close-bag>Continue shopping</a></div>`;
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    list.innerHTML = cart.items.map((it, i) => {
      const line = i + 1;
      const opts = it.product_has_only_default_variant ? '' : `<p class="sm dim opts">${esc(it.variant_title)}</p>`;
      const img = it.image ? `<img src="${esc(sized(it.image, 200))}" alt="" width="84" height="105" loading="lazy">` : '<span></span>';
      return `<div class="item">
        ${img}
        <div>
          <h4><a href="${esc(it.url)}">${esc(it.product_title)}</a></h4>
          ${opts}
          <div class="qty" role="group" aria-label="Quantity for ${esc(it.product_title)}">
            <button type="button" data-line="${line}" data-qty="${it.quantity - 1}" aria-label="Decrease quantity">−</button>
            <span>${it.quantity}</span>
            <button type="button" data-line="${line}" data-qty="${it.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <div class="item-side">
          <span>${money(it.final_line_price)}</span>
          <button class="rm" type="button" data-line="${line}" data-qty="0">Remove</button>
        </div>
      </div>`;
    }).join('');
    if (total) total.textContent = money(cart.total_price);
  }
  async function changeLine(line, quantity) {
    const r = await fetch(L.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    const data = await r.json();
    if (!r.ok) { toast(data.description || 'Could not update your bag'); return; }
    renderCart(data);
  }
  async function addItems(body, isForm) {
    const r = await fetch(L.cartAdd + '.js', isForm
      ? { method: 'POST', headers: { Accept: 'application/json' }, body }
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.description || data.message || 'Could not add to bag');
    return data;
  }

  async function openBag() {
    if (!bagEl) { window.location.href = L.cartUrl; return; }
    lastFocus = document.activeElement;
    try { renderCart(await fetchCart()); } catch (e) {}
    bagEl.classList.add('on'); bagEl.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('on');
    lock();
    setTimeout(() => { const c = $('#bag-close'); if (c) c.focus(); }, 60);
  }
  function closeBag() {
    if (!bagEl) return;
    bagEl.classList.remove('on'); bagEl.setAttribute('aria-hidden', 'true');
    if (scrim && !(mnav && mnav.classList.contains('on'))) scrim.classList.remove('on');
    lock();
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }
  $$('[data-open-bag]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openBag(); }));
  const bagClose = $('#bag-close'); if (bagClose) bagClose.addEventListener('click', closeBag);
  if (bagEl) bagEl.addEventListener('click', e => {
    const b = e.target.closest('[data-line]');
    if (b) { changeLine(+b.dataset.line, Math.max(0, +b.dataset.qty)); return; }
    if (e.target.closest('[data-close-bag]')) closeBag();
  });

  /* ---------- mobile menu ---------- */
  const menuOpen = $('#menu-open'), menuClose = $('#menu-close');
  function openMenu() {
    if (!mnav) return;
    mnav.classList.add('on'); mnav.setAttribute('aria-hidden', 'false');
    if (menuOpen) menuOpen.setAttribute('aria-expanded', 'true');
    if (scrim) scrim.classList.add('on');
    lock();
    setTimeout(() => menuClose && menuClose.focus(), 60);
  }
  function closeMenu(restore = true) {
    if (!mnav) return;
    mnav.classList.remove('on'); mnav.setAttribute('aria-hidden', 'true');
    if (menuOpen) menuOpen.setAttribute('aria-expanded', 'false');
    if (scrim && !(bagEl && bagEl.classList.contains('on'))) scrim.classList.remove('on');
    lock();
    if (restore && menuOpen) menuOpen.focus({ preventScroll: true });
  }
  if (menuOpen) menuOpen.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', () => closeMenu());
  $$('[data-close-menu]').forEach(a => a.addEventListener('click', () => closeMenu(false)));
  if (scrim) scrim.addEventListener('click', () => {
    if (bagEl && bagEl.classList.contains('on')) closeBag();
    if (mnav && mnav.classList.contains('on')) closeMenu();
  });

  /* ---------- quick add on product cards ---------- */
  $$('[data-card]').forEach(card => {
    const btn = $('[data-quick]', card), panel = $('.quick-sizes', card);
    if (!btn || !panel) return;
    const closeAll = () => $$('[data-card]').forEach(c => {
      const p = $('.quick-sizes', c), b = $('[data-quick]', c);
      if (p) p.hidden = true; if (b) b.setAttribute('aria-expanded', 'false'); c.classList.remove('is-quick');
    });
    btn.addEventListener('click', () => {
      const open = panel.hidden;
      closeAll();
      panel.hidden = !open; card.classList.toggle('is-quick', open); btn.setAttribute('aria-expanded', String(open));
      if (open) { const first = $('button:not([disabled])', panel); if (first) first.focus(); }
    });
    panel.addEventListener('click', async e => {
      const b = e.target.closest('[data-variant]');
      if (!b || b.disabled) return;
      b.disabled = true;
      try {
        await addItems({ items: [{ id: +b.dataset.variant, quantity: 1 }] });
        closeAll();
        openBag();
      } catch (err) { toast(err.message); }
      b.disabled = false;
    });
  });

  /* ---------- product form ---------- */
  const form = $('#product-form');
  if (form) {
    const add = $('#pv-add'), msg = $('#pv-msg'), sizes = $('#pv-sizes');
    form.addEventListener('change', e => {
      const r = e.target.closest('input[name="id"]');
      if (r && add) { add.textContent = 'Add to bag — ' + r.dataset.price; if (msg) msg.textContent = ''; }
    });
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (!form.querySelector('input[name="id"]:checked') && form.querySelector('input[type="radio"][name="id"]')) {
        if (sizes) { sizes.classList.remove('nudge'); void sizes.offsetWidth; sizes.classList.add('nudge'); }
        if (msg) msg.textContent = 'Choose a size first.';
        return;
      }
      if (add) add.disabled = true;
      try {
        await addItems(new FormData(form), true);
        if (msg) msg.textContent = '';
        openBag();
      } catch (err) {
        if (msg) msg.textContent = err.message;
      }
      if (add) add.disabled = false;
    });
  }

  /* ---------- cookie preferences (Shopify's own cookie banner) ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-cookie-prefs]');
    if (!b) return;
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    } else if (b.dataset.fallback) {
      window.location.href = b.dataset.fallback;
    }
  });

  /* ---------- copy email ---------- */
  const copy = $('#copy-email');
  if (copy) copy.addEventListener('click', async () => {
    const el = $('#email-text');
    try { await navigator.clipboard.writeText(el.textContent.trim()); toast('Email copied'); }
    catch (e) {
      const r = document.createRange(); r.selectNodeContents(el);
      const s = getSelection(); s.removeAllRanges(); s.addRange(r); toast('Email selected — copy it');
    }
  });

  /* ---------- keyboard ---------- */
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if (bagEl && bagEl.classList.contains('on')) closeBag();
    else if (mnav && mnav.classList.contains('on')) closeMenu();
    else $$('[data-card].is-quick [data-quick]').forEach(b => b.click());
  });

  /* initial cart state (keeps counts right after back/forward navigation) */
  window.addEventListener('pageshow', ev => { if (ev.persisted) fetchCart().then(renderCart).catch(() => {}); });
})();
